import React, { useEffect, useRef } from 'react'
import useStyles from './styles'
import { Typography, Chip } from '@material-ui/core'
import { formatMoney } from 'accounting'
import { useSelector } from 'react-redux'
import classnames from 'clsx'
import TextClamp from 'react-string-clamp'
import useNameStyle from 'hooks/useNameStyle'

const Purcahse = ({ purchase, scrollEffect = false, parentRef }) => {
  const classes = useStyles()
  const purchaseRef = useRef(null)
  let parentHeight = 0

  const calculateScrollEffect = () => {
    const bottomOffset =
      purchaseRef.current.offsetTop + purchaseRef.current.offsetHeight
    purchaseRef.current.style.opacity = bottomOffset / parentHeight
  }

  const purchaseId = useSelector(
    state => state.items.purchaseIds[purchase.user_id]
  )

  const styledName = useNameStyle(purchase.user_name)

  useEffect(() => {
    if (scrollEffect) {
      parentHeight = Math.round(parentRef.current.clientHeight)
      calculateScrollEffect()
    }
  }, [scrollEffect])

  return (
    <figure className={classes.purchase}>
      {styledName === 'paddle_number' && (
        <Chip className={classes.chip} color="primary" label={purchaseId} />
      )}
      <Typography variant="h3" className={classes.purchaserName}>
        <TextClamp
          text={styledName === 'paddle_number' ? '' : styledName}
          lines={1}
        />
      </Typography>
      <Typography variant="h3" className={classes.purchaseAmount}>
        {formatMoney(purchase.item_cost * purchase.qty, '$', 0)}
      </Typography>
    </figure>
  )
}

export default Purcahse



// WEBPACK FOOTER //
// ./src/components/EngagementsBoard/PurchaseList/Purchase/index.jsx